// Re-export all the API functions from sms.js that are used in ReceiveCode
export { 
  getUserBalance,
  getSuccessRate,
  searchProjects,
  getProjectChannels,
  addChannelConnection,
  getProjectPhone,
  getPhoneVerificationCode,
  releasePhoneNumber,
  blacklistPhone,
  applyProject,
  activateCard,
  getUsdtQuotedPrice,
  calcUsdtPrice,
  checkUsdtRecharge,
  getLatestNotice
} from './sms'

export { isAuthenticated } from './user'

// Create a default export object for convenience
import * as smsApi from './sms'
import * as userApi from './user'

export default {
  ...smsApi,
  ...userApi
}